<template>
    <span class="badge" :class="('badge-' + variant)"><slot></slot></span>
</template>

<script>
export default {
    props: {
        variant: {
            required: true,
            type: String,
        }
    }
}
</script>
